import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapItineraryListPage,
  mapFinalizedBudgetQuoteVersions,
  mapItineraryNlQueryParsePayload,
  mapItineraryNlQueryParseResult,
  type ItineraryListPageRaw,
  type FinalizedBudgetQuoteVersionsResponseRaw,
  type ItineraryNlQueryParseResultRaw,
} from "../api/adapters";
import type {
  ItineraryListPage,
  ItineraryListParams,
  FinalizedBudgetQuoteVersion,
  ItineraryNlQueryParseResult,
} from "../types";

/** repo 层导出入口（由脚手架生成）。 */
export * from "./itineraryRepo";

/** 查询课程线路分页数据。 */
export async function fetchItineraryListPage(
  params: ItineraryListParams,
): Promise<ItineraryListPage> {
  const response = await httpClient.get<ApiEnvelope<ItineraryListPageRaw>>("/itineraries", {
    params: {
      scope: params.scope,
      itinerary_id: params.itineraryId,
      keyword: params.keyword,
      school_name: params.schoolName,
      sales_user_id: params.salesUserId,
      dispatcher_user_id: params.dispatcherUserId,
      major_names: params.majorNames,
      duration_days: params.durationDays,
      province_names: params.provinceNames,
      stay_area_names: params.stayAreaNames,
      point_names: params.pointNames,
      sort_by: params.sortBy,
      sort_order: params.sortOrder,
      page: params.page,
      page_size: params.pageSize,
    },
    paramsSerializer: { indexes: null },
    timeout: 15_000,
    "axios-retry": { retries: 0 },
  });
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("课程线路列表接口返回了无效数据");
  }
  return mapItineraryListPage(response.data.data);
}

/** 查询当前行程全部已定稿核价及其对应报价，按核价版本倒序返回。 */
export async function fetchFinalizedBudgetQuoteVersions(
  itineraryId: string,
): Promise<FinalizedBudgetQuoteVersion[]> {
  const response = await httpClient.get<FinalizedBudgetQuoteVersionsResponseRaw>(
    `/itineraries/${encodeURIComponent(itineraryId)}/finalized-budgets`,
    { timeout: 15_000, "axios-retry": { retries: 0 } },
  );
  if (response.data.code !== "OK") {
    throw new Error("定稿核价列表接口返回了无效数据");
  }
  return mapFinalizedBudgetQuoteVersions(response.data.data ?? []);
}

/** 解析课程线路自然语言筛选。 */
export async function parseItineraryNlQuery(query: string): Promise<ItineraryNlQueryParseResult> {
  const response = await httpClient.post<ApiEnvelope<ItineraryNlQueryParseResultRaw>>(
    "/itineraries/nl-query/parse",
    mapItineraryNlQueryParsePayload(query),
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("课程线路 AI 筛选接口返回了无效数据");
  }
  return mapItineraryNlQueryParseResult(response.data.data);
}
